// 路由配置
const routes = [
  {
    path: '/',
    name: '首页',
    redirect: '/login'
  },
  {
    path: '/login',
    name: '登录页',
    component: () => import('@/views/public/login')
  },
  // ----------- work-wx router config -------------
  {
    path: '/work-wx/main',
    name: '主页',
    component: () => import('@/views/work-wx/main')
  },
  {
    path: '/work-wx/appoint/main',
    name: '产品预约',
    component: () => import('@/views/work-wx/appoint/main')
  },
  {
    path: '/work-wx/appoint/application',
    name: '产品预约 ',
    component: () => import('@/views/work-wx/appoint/application')
  },
  {
    path: '/work-wx/appoint/application/detail',
    name: '产品预约申请',
    component: () => import('@/views/work-wx/appoint/application/detail')
  },
  {
    path: '/work-wx/appoint/query',
    name: '预约查询',
    component: () => import('@/views/work-wx/appoint/query')
  },
  {
    path: '/work-wx/appoint/query/detail',
    name: '预约查询明细',
    component: () => import('@/views/work-wx/appoint/query/detail')
  },
  {
    path: '/work-wx/appoint/queue',
    name: '预约排队',
    component: () => import('@/views/work-wx/appoint/queue')
  },
  {
    path: '/work-wx/product/net-worth',
    name: '产品净值',
    component: () => import('@/views/work-wx/product/net-worth')
  },
  {
    path: '/work-wx/product/net-worth/detail',
    name: '产品净值明细',
    component: () => import('@/views/work-wx/product/net-worth/detail')
  },
  {
    path: '/work-wx/customer/main',
    name: '我的客户',
    component: () => import('@/views/work-wx/customer/main')
  },
  {
    path: '/work-wx/customer/query/editor/:customerId?',
    name: '客户信息',
    component: () => import('@/views/work-wx/customer/query/editor')
  },
  {
    path: '/work-wx/customer/query',
    name: '客户查询',
    component: () => import('@/views/work-wx/customer/query')
  },
  {
    path: '/work-wx/customer/visitor/record/:customerId',
    name: '客户拜访记录',
    component: () => import('@/views/work-wx/customer/visitor/record')
  },
  {
    path: '/work-wx/customer/invest/record/:customerId',
    name: '客户投资记录',
    component: () => import('@/views/work-wx/customer/invest/record')
  },
  {
    path: '/work-wx/customer/visitor/editor',
    name: '新增客户拜访记录',
    component: () => import('@/views/work-wx/customer/visitor/editor')
  },
  {
    path: '/work-wx/customer/query/identify',
    name: '陌生签单客户识别',
    component: () => import('@/views/work-wx/customer/query/identify')
  },
  {
    path: '/work-wx/redemption',
    name: '赎回管理',
    component: () => import('@/views/work-wx/redemption')
  },
  {
    path: '/work-wx/redemption/application',
    name: '存续产品',
    component: () => import('@/views/work-wx/redemption/application'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/redemption/record',
    name: '赎回记录',
    component: () => import('@/views/work-wx/redemption/record'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/redemption/:redemptionId?/customer/:customerId/product/:productId',
    name: 'redemptionDetail',
    component: () => import('@/views/work-wx/redemption/detail/RefreshRedemptionDetail'),
    props: true,
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/trade',
    name: '交易管理',
    component: () => import('@/views/work-wx/trade')
  },
  {
    path: '/work-wx/trade/input',
    name: '交易录入',
    component: () => import('@/views/work-wx/trade/input'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/trade/record',
    name: '交易查询',
    component: () => import('@/views/work-wx/trade/record'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/trade/input/TradeDetail/trade/:tradeId?/appointment/:appointmentId?',
    name: '交易详情',
    component: () => import('@/views/work-wx/trade/input/TradeDetail'),
    props: true,
    meta: {
      keepAlive: true,
    }
  },
  // {
  //   path: '/work-wx/trade/input/TradeDetail',
  //   name: '交易详情',
  //   component: () => import('@/views/work-wx/trade/input/TradeDetail'),
  //   props: true,
  //   meta: {
  //     keepAlive: true,
  //   }
  // },
  {
    path: '/work-wx/synthetical',
    name: '综合查询',
    component: () => import('@/views/work-wx/synthetical')
  },
  {
    path: '/work-wx/synthetical/product',
    name: '产品查询',
    component: () => import('@/views/work-wx/synthetical/product'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/synthetical/product/detail/:productId',
    name: '产品明细',
    component: () => import('@/views/work-wx/synthetical/product/detail'),
  },
  {
    path: '/work-wx/synthetical/float-invest',
    name: '权益类投资查询',
    component: () => import('@/views/work-wx/synthetical/float-invest'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/synthetical/float-invest/detail/:customerId/:productId',
    name: '权益类投资明细',
    component: () => import('@/views/work-wx/synthetical/float-invest/detail'),
  },
  {
    path: '/work-wx/synthetical/commission',
    name: '业务费查询',
    component: () => import('@/views/work-wx/synthetical/commission'),
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/work-wx/synthetical/commission/commission',
    name: '财富业务费明细',
    component: () => import('@/views/work-wx/synthetical/commission/commission')
  },
  {
    path: '/work-wx/synthetical/commission/manageBonus',
    name: '财富管理奖金明细',
    component: () => import('@/views/work-wx/synthetical/commission/manageBonus')
  },
  {
    path: '/work-wx/synthetical/commission/insCommission',
    name: '保险业务费明细',
    component: () => import('@/views/work-wx/synthetical/commission/insCommission')
  },
  {
    path: '/work-wx/synthetical/commission/insManageBonus',
    name: '保险管理奖金明细',
    component: () => import('@/views/work-wx/synthetical/commission/insManageBonus')
  },
  {
    path: '/work-wx/synthetical/commission/eliteBonus',
    name: '英才奖&超额英才奖明细',
    component: () => import('@/views/work-wx/synthetical/commission/eliteBonus')
  },
  {
    path: '/work-wx/synthetical/commission/commissionExtra',
    name: '加扣款明细',
    component: () => import('@/views/work-wx/synthetical/commission/commissionExtra')
  },
  {
    path: '/work-wx/synthetical/commission/inspireBonus',
    name: '特别激励奖明细',
    component: () => import('@/views/work-wx/synthetical/commission/inspireBonus')
  },
  // ----------- wx router config -------------
  {
    path: '/wx/login',
    name: '登录',
    component: () => import('@/views/wx/login'),
    meta: {
      keepAlive: true,
    }
  },
  // 登录---隐私页面
  {
    path: '/loginPrivacy',
    name: '绿城财富平台用户服务协议',
    component: () => import('@/views/wx/login/privacy'),
  },
  // 跳转到长量页面
  {
    path: '/jumpToChangliang',
    name: '长量页面',
    component: () => import('@/views/wx/jump/changliang'),
  },
  // 跳转到通华页面
  {
    path: '/jumpToTonghua',
    name: '通华页面',
    component: () => import('@/views/wx/jump/tonghua'),
  },
  // 跳转到利得页面
  {
    path: '/jumpToLide',
    name: '利得页面',
    component: () => import('@/views/wx/jump/lide'),
  },
  // 跳转到利得页面2
  {
    path: '/jumpToFundLD',
    name: '利得页面2',
    component: () => import('@/views/wx/jump/fundLD'),
  },
  {
    path: '/wx/pwd-lock',
    name: '手势密码',
    component: () => import('@/views/wx/pwd-lock')
  },
  {
    path: '/wx/main',
    name: '我的资产',
    component: () => import('@/views/wx/main')
  },
  {
    path: '/wx/mine',
    name: '个人资料',
    component: () => import('@/views/wx/mine')
  },
  {
    path: '/wx/addrs',
    name: '联系地址',
    component: () => import('@/views/wx/addrs')
  },
  {
    path: '/wx/addr',
    name: '我的地址',
    component: () => import('@/views/wx/addrs/editor')
  },
  {
    path: '/wx/updateEmail',
    name: '修改邮箱',
    component: () => import('@/views/wx/updateEmail')
  },
  {
    path: '/wx/updateEmail/personal',
    name: '个人信息维护',
    component: () => import('@/views/wx/updateEmail/edit')
  },
  {
    path: '/wx/hold-assets',
    name: '存续资产',
    component: () => import('@/views/wx/hold-assets')
  },
  {
    path: '/wx/redemption',
    name: '到期/赎回资产',
    component: () => import('@/views/wx/redemption')
  },
  {
    path: '/wx/agent',
    name: '我的财富顾问',
    component: () => import('@/views/wx/agent')
  },
  // ----------- other -------------
  {
    path: '/attachment/b/:businessId?/t/:attachmentType/f/:flag?',
    name: 'attachmentDetail',
    component: () => import('@/views/public/attachment'),
    props: true
  },
  {
    path: '/workflow/b/:businessId/d/:workFlowDefinitionId',
    name: 'workFlowDetail',
    component: () => import('@/views/public/workflow'),
    props: true
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/public/exception/404')
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/public/exception/403')
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/public/exception/500')
  },
  
]

export default routes
